import { ApiError } from '../../../lib/apiClient.js';

export function smsErrorText(error: unknown): string {
  if (error instanceof ApiError) {
    return error.envelope.error.details?.[0]?.message ?? error.message;
  }
  return 'ذخیره انجام نشد؛ دوباره تلاش کنید.';
}
